<template>
  <div class="footer">
    <div class="row g-4 mw-100">
      <div class="col-md-4" v-for="(menu, index) in menus" :key="index">
        <h5 class="title">{{ menu.mainTitle }}</h5>
        <ul>
          <li v-for="(item, index) in menu.items" :key="index">
            <a @click="goSelectMenu(item)">{{ item.subTitle }}</a>
          </li>
        </ul>
      </div>

      <div class="col-md-4">
        <h5 class="title">İletişim Bilgileri</h5>
        <div class="info d-flex flex-column justify-content-between gap-4">
          <p class="address">Pazar Mahallesi Yılmaz Telatar Caddesi No:1<br />Pazar/Rize</p>
          <p class="contact-info d-flex flex-column">
            <span
              >WhatsApp:
              <a href="https://api.whatsapp.com/send/?phone=905321779666&text&type=phone_number&app_absent=0" target="_blank"> 0532 177 9666 </a>
            </span>
            <span><a>0 (464) 612-1130</a><b>&nbsp;-&nbsp;</b><a>0(464) 612-1134 </a></span>
            <span><a href="mailto:pazar@pazar.bel.tr">pazar@pazar.bel.tr</a></span>
          </p>
        </div>
      </div>
      <div class="col-md-4 gap-3">
        <div class="socials">
          <div class="fb social-item">
            <a href="https://www.facebook.com/PazarBld/" target="_blank">
              <svg enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g>
                  <path d="M32,30c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2c0-1.104,0.896-2,2-2h28c1.104,0,2,0.896,2,2V30z" fill="#3B5998" />
                  <path d="M22,32V20h4l1-5h-5v-2c0-2,1.002-3,3-3h2V5c-1,0-2.24,0-4,0c-3.675,0-6,2.881-6,7v3h-4v5h4v12H22z" fill="#FFFFFF" id="f" />
                </g>
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
              </svg>
            </a>
          </div>
          <div class="insta social-item">
            <a href="https://www.instagram.com/rizepazarbelediyesi/" target="_blank">
              <svg enable-background="new 0 0 128 128" id="Social_Icons" version="1.1" viewBox="0 0 128 128" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="_x37__stroke">
                  <g id="Instagram_1_">
                    <rect clip-rule="evenodd" fill="none" fill-rule="evenodd" height="128" width="128" />
                    <radialGradient cx="19.1111" cy="128.4444" gradientUnits="userSpaceOnUse" id="Instagram_2_" r="163.5519">
                      <stop offset="0" style="stop-color: #ffb140" />
                      <stop offset="0.2559" style="stop-color: #ff5445" />
                      <stop offset="0.599" style="stop-color: #fc2b82" />
                      <stop offset="1" style="stop-color: #8e40b7" />
                    </radialGradient>
                    <path
                      clip-rule="evenodd"
                      d="M105.843,29.837    c0,4.242-3.439,7.68-7.68,7.68c-4.241,0-7.68-3.438-7.68-7.68c0-4.242,3.439-7.68,7.68-7.68    C102.405,22.157,105.843,25.595,105.843,29.837z M64,85.333c-11.782,0-21.333-9.551-21.333-21.333    c0-11.782,9.551-21.333,21.333-21.333c11.782,0,21.333,9.551,21.333,21.333C85.333,75.782,75.782,85.333,64,85.333z M64,31.135    c-18.151,0-32.865,14.714-32.865,32.865c0,18.151,14.714,32.865,32.865,32.865c18.151,0,32.865-14.714,32.865-32.865    C96.865,45.849,82.151,31.135,64,31.135z M64,11.532c17.089,0,19.113,0.065,25.861,0.373c6.24,0.285,9.629,1.327,11.884,2.204    c2.987,1.161,5.119,2.548,7.359,4.788c2.24,2.239,3.627,4.371,4.788,7.359c0.876,2.255,1.919,5.644,2.204,11.884    c0.308,6.749,0.373,8.773,0.373,25.862c0,17.089-0.065,19.113-0.373,25.861c-0.285,6.24-1.327,9.629-2.204,11.884    c-1.161,2.987-2.548,5.119-4.788,7.359c-2.239,2.24-4.371,3.627-7.359,4.788c-2.255,0.876-5.644,1.919-11.884,2.204    c-6.748,0.308-8.772,0.373-25.861,0.373c-17.09,0-19.114-0.065-25.862-0.373c-6.24-0.285-9.629-1.327-11.884-2.204    c-2.987-1.161-5.119-2.548-7.359-4.788c-2.239-2.239-3.627-4.371-4.788-7.359c-0.876-2.255-1.919-5.644-2.204-11.884    c-0.308-6.749-0.373-8.773-0.373-25.861c0-17.089,0.065-19.113,0.373-25.862c0.285-6.24,1.327-9.629,2.204-11.884    c1.161-2.987,2.548-5.119,4.788-7.359c2.239-2.24,4.371-3.627,7.359-4.788c2.255-0.876,5.644-1.919,11.884-2.204    C44.887,11.597,46.911,11.532,64,11.532z M64,0C46.619,0,44.439,0.074,37.613,0.385C30.801,0.696,26.148,1.778,22.078,3.36    c-4.209,1.635-7.778,3.824-11.336,7.382C7.184,14.3,4.995,17.869,3.36,22.078c-1.582,4.071-2.664,8.723-2.975,15.535    C0.074,44.439,0,46.619,0,64c0,17.381,0.074,19.561,0.385,26.387c0.311,6.812,1.393,11.464,2.975,15.535    c1.635,4.209,3.824,7.778,7.382,11.336c3.558,3.558,7.127,5.746,11.336,7.382c4.071,1.582,8.723,2.664,15.535,2.975    C44.439,127.926,46.619,128,64,128c17.381,0,19.561-0.074,26.387-0.385c6.812-0.311,11.464-1.393,15.535-2.975    c4.209-1.636,7.778-3.824,11.336-7.382c3.558-3.558,5.746-7.127,7.382-11.336c1.582-4.071,2.664-8.723,2.975-15.535    C127.926,83.561,128,81.381,128,64c0-17.381-0.074-19.561-0.385-26.387c-0.311-6.812-1.393-11.464-2.975-15.535    c-1.636-4.209-3.824-7.778-7.382-11.336c-3.558-3.558-7.127-5.746-11.336-7.382c-4.071-1.582-8.723-2.664-15.535-2.975    C83.561,0.074,81.381,0,64,0z"
                      fill="url(#Instagram_2_)"
                      fill-rule="evenodd"
                      id="Instagram"
                    />
                  </g>
                </g>
              </svg>
            </a>
          </div>
          <div class="wp social-item">
            <a href="https://api.whatsapp.com/send/?phone=905321779666&text&type=phone_number&app_absent=0" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" version="1.1">
                <path
                  d="M 238 97.096 C 185.872 102.914, 138.747 135.698, 114.657 182.903 C 102.999 205.748, 97.571 228.954, 97.676 255.500 C 97.766 278.156, 101.398 296.156, 110.066 316.900 C 112.230 322.078, 114 327.041, 114 327.928 C 114 328.815, 110.400 346.989, 106 368.313 C 101.600 389.638, 98 408.347, 98 409.888 C 98 412.817, 100.643 415.999, 103.079 416.002 C 103.860 416.003, 122.643 411.700, 144.818 406.441 L 185.136 396.879 193.318 400.354 C 203.283 404.586, 214.673 408.171, 226 410.641 C 232.801 412.124, 238.798 412.495, 256 412.497 C 274.841 412.500, 278.779 412.214, 287.844 410.184 C 337.068 399.161, 376.126 369.043, 397.923 325.302 C 410.801 299.460, 416.567 270.015, 414.124 242.579 C 412.096 219.818, 407.630 203.931, 397.514 183.500 C 368.341 124.583, 303.999 89.731, 238 97.096 M 245.500 131.093 C 229.075 132.390, 214.840 136.530, 199 144.617 C 145.097 172.135, 119.235 235.151, 137.997 293.259 C 139.638 298.341, 143.181 306.862, 145.869 312.193 L 150.757 321.885 145.845 345.648 C 143.143 358.717, 141.060 369.933, 141.216 370.572 C 141.410 371.365, 149.124 369.929, 165.497 366.054 L 189.494 360.374 200.497 365.583 C 212.855 371.434, 223.905 375.127, 235 377.114 C 245.629 379.019, 268.469 378.781, 279.275 376.654 C 324.057 367.838, 360.859 335.151, 374.394 292.172 C 388.404 247.682, 376.177 198.777, 342.912 166.253 C 332.661 156.230, 325.254 150.873, 313 144.617 C 291.296 133.538, 269.594 129.190, 245.500 131.093 M 199.224 179.041 C 194.809 180.814, 183.276 193.694, 179.827 200.703 C 176.691 207.076, 176.501 208.070, 176.518 217.982 C 176.540 230.613, 178.808 238.996, 185.819 252.357 C 199.552 278.527, 236.786 312.752, 263.900 324.127 C 284.667 332.839, 305.705 334.272, 318.324 327.835 C 323.830 325.026, 332.263 316.857, 337.038 309.705 C 342.011 302.259, 342.352 297.541, 338.250 292.960 C 335.886 290.321, 333.041 289.182, 318.002 284.854 C 296.816 278.758, 295.806 278.808, 288.062 286.354 C 281.520 292.727, 279.305 294, 274.757 294 C 268.196 294, 250.751 281.628, 233.864 265 C 215.011 246.435, 213.556 241.955, 222.500 230 C 226.565 224.566, 228 221.789, 228 219.355 C 228 216.459, 219.813 196.394, 213.911 184.826 C 211.033 179.183, 204.892 176.765, 199.224 179.041"
                  stroke="none"
                  fill="#fafbfa"
                  fill-rule="evenodd"
                />
                <path
                  d="M 52.500 1.966 C 43.007 4.501, 38.676 6.431, 30.845 11.619 C 18.295 19.933, 8.602 32.573, 3.324 47.510 L 0.500 55.500 0.500 256 L 0.500 456.500 3.324 464.490 C 10.696 485.352, 26.236 501.023, 46.882 508.415 L 55.500 511.500 256 511.500 L 456.500 511.500 464.490 508.676 C 479.572 503.347, 492.037 493.730, 500.643 480.785 C 505.185 473.953, 510.960 459.730, 510.987 455.309 C 510.994 454.104, 511.450 452.840, 512 452.500 C 512.661 452.091, 513 385.137, 513 254.882 C 513 123.803, 512.665 58.089, 512 58.500 C 511.450 58.840, 511 58.158, 511 56.985 C 511 55.812, 509.845 51.398, 508.434 47.176 C 501.617 26.781, 485.578 10.776, 464.490 3.324 L 456.500 0.500 258 0.299 C 66.959 0.105, 59.237 0.168, 52.500 1.966 M 0.490 256 C 0.490 364.625, 0.607 409.062, 0.750 354.750 C 0.893 300.437, 0.893 211.562, 0.750 157.250 C 0.607 102.937, 0.490 147.375, 0.490 256 M 238 97.096 C 185.872 102.914, 138.747 135.698, 114.657 182.903 C 102.999 205.748, 97.571 228.954, 97.676 255.500 C 97.766 278.156, 101.398 296.156, 110.066 316.900 C 112.230 322.078, 114 327.041, 114 327.928 C 114 328.815, 110.400 346.989, 106 368.313 C 101.600 389.638, 98 408.347, 98 409.888 C 98 412.817, 100.643 415.999, 103.079 416.002 C 103.860 416.003, 122.643 411.700, 144.818 406.441 L 185.136 396.879 193.318 400.354 C 203.283 404.586, 214.673 408.171, 226 410.641 C 232.801 412.124, 238.798 412.495, 256 412.497 C 274.841 412.500, 278.779 412.214, 287.844 410.184 C 337.068 399.161, 376.126 369.043, 397.923 325.302 C 410.801 299.460, 416.567 270.015, 414.124 242.579 C 412.096 219.818, 407.630 203.931, 397.514 183.500 C 368.341 124.583, 303.999 89.731, 238 97.096 M 245.500 131.093 C 229.075 132.390, 214.840 136.530, 199 144.617 C 145.097 172.135, 119.235 235.151, 137.997 293.259 C 139.638 298.341, 143.181 306.862, 145.869 312.193 L 150.757 321.885 145.845 345.648 C 143.143 358.717, 141.060 369.933, 141.216 370.572 C 141.410 371.365, 149.124 369.929, 165.497 366.054 L 189.494 360.374 200.497 365.583 C 212.855 371.434, 223.905 375.127, 235 377.114 C 245.629 379.019, 268.469 378.781, 279.275 376.654 C 324.057 367.838, 360.859 335.151, 374.394 292.172 C 388.404 247.682, 376.177 198.777, 342.912 166.253 C 332.661 156.230, 325.254 150.873, 313 144.617 C 291.296 133.538, 269.594 129.190, 245.500 131.093 M 199.224 179.041 C 194.809 180.814, 183.276 193.694, 179.827 200.703 C 176.691 207.076, 176.501 208.070, 176.518 217.982 C 176.540 230.613, 178.808 238.996, 185.819 252.357 C 199.552 278.527, 236.786 312.752, 263.900 324.127 C 284.667 332.839, 305.705 334.272, 318.324 327.835 C 323.830 325.026, 332.263 316.857, 337.038 309.705 C 342.011 302.259, 342.352 297.541, 338.250 292.960 C 335.886 290.321, 333.041 289.182, 318.002 284.854 C 296.816 278.758, 295.806 278.808, 288.062 286.354 C 281.520 292.727, 279.305 294, 274.757 294 C 268.196 294, 250.751 281.628, 233.864 265 C 215.011 246.435, 213.556 241.955, 222.500 230 C 226.565 224.566, 228 221.789, 228 219.355 C 228 216.459, 219.813 196.394, 213.911 184.826 C 211.033 179.183, 204.892 176.765, 199.224 179.041"
                  stroke="none"
                  fill="#2ca41c"
                  fill-rule="evenodd"
                />
              </svg>
            </a>
          </div>
          <div class="x social-item">
            <a href="https://twitter.com/rizepazarbel" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2400 2453" version="1.1">
                <path
                  d="M 1.550 2.749 C 2.529 4.262, 213.211 310.962, 469.731 684.304 C 726.251 1057.646, 935.989 1363.473, 935.815 1363.919 C 935.642 1364.366, 725.125 1609.227, 468 1908.056 C 210.875 2206.885, 0.350 2451.746, 0.167 2452.191 C -0.017 2452.636, 47.683 2452.970, 106.167 2452.933 L 212.500 2452.866 621.397 1977.399 C 846.291 1715.892, 1030.661 1502.059, 1031.109 1502.216 C 1031.556 1502.372, 1178.795 1716.250, 1358.306 1977.500 L 1684.690 2452.500 2042.511 2452.500 C 2347.002 2452.500, 2400.402 2452.293, 2400.796 2451.111 C 2401.051 2450.347, 2400.809 2450, 2400.259 2450.340 C 2399.709 2450.680, 2180.928 2133.215, 1914.079 1744.863 C 1483.313 1117.956, 1429.058 1038.584, 1430.303 1037.134 C 1437.836 1028.360, 2319.651 3.055, 2320.787 1.750 C 2322.236 0.085, 2317.156 0, 2215.882 0 L 2109.455 0 1722.114 450.250 C 1509.076 697.888, 1334.486 900.374, 1334.136 900.219 C 1333.786 900.065, 1194.447 697.565, 1024.493 450.219 L 715.486 0.500 357.627 0.249 L -0.232 -0.003 1.550 2.749 M 293.269 166.250 C 297.639 172.394, 869.759 990.761, 1475.271 1857 C 1644.625 2099.275, 1783.724 2298.064, 1784.382 2298.753 C 1785.332 2299.749, 1818.738 2299.954, 1947.235 2299.753 L 2108.893 2299.500 1404.900 1292.500 C 1017.704 738.650, 681.241 257.290, 657.204 222.811 L 613.500 160.122 451.162 160.061 L 288.824 160 293.269 166.250"
                  stroke="none"
                  fill="#fffcfc"
                  fill-rule="evenodd"
                />
                <path d="" stroke="none" fill="#fcfcfc" fill-rule="evenodd" />
              </svg>
            </a>
          </div>
          <div class="vet social-item">
            <a href="https://api.whatsapp.com/send/?phone=905353338353&text&type=phone_number&app_absent=0" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="225" height="225" viewBox="0 0 64 64" version="1.1">
                <path d="" stroke="none" fill="#000" fill-rule="evenodd" />
                <path
                  d="M 30.434 1.312 C 29.339 4.165, 30.419 10.500, 32 10.500 C 33.130 10.500, 33.500 9.287, 33.500 5.583 C 33.500 0.741, 31.645 -1.844, 30.434 1.312 M 14 2.552 C 14 4.374, 18.183 11.981, 19.191 11.992 C 21.137 12.014, 20.882 9.474, 18.535 5.470 C 15.879 0.937, 14 -0.272, 14 2.552 M 45.465 5.470 C 43.118 9.474, 42.863 12.014, 44.809 11.992 C 45.817 11.981, 50 4.374, 50 2.552 C 50 -0.272, 48.121 0.937, 45.465 5.470 M 0.533 13.946 C -0.096 14.965, 6.674 20, 8.673 20 C 11.629 20, 10.691 17.903, 6.686 15.556 C 1.832 12.711, 1.371 12.591, 0.533 13.946 M 57.160 15.620 C 53.913 17.566, 53.107 18.507, 53.960 19.360 C 55.380 20.780, 62.331 17.053, 62.823 14.607 C 63.267 12.403, 62.213 12.591, 57.160 15.620 M 14.729 16.750 C 13.755 17.828, 12.058 24.816, 10.306 34.959 C 7.598 50.640, 7.346 51.446, 4.982 52.004 C 2.714 52.540, 2.500 53.061, 2.500 58.045 L 2.500 63.500 32 63.500 L 61.500 63.500 61.500 58.045 C 61.500 53.061, 61.286 52.540, 59.018 52.004 C 56.654 51.446, 56.402 50.640, 53.694 34.959 C 51.942 24.816, 50.245 17.828, 49.271 16.750 C 47.893 15.225, 45.674 15, 32 15 C 18.326 15, 16.107 15.225, 14.729 16.750 M 17.208 19.250 C 16.361 20.272, 11 47.726, 11 51.042 C 11 51.577, 14.750 52, 19.500 52 C 26.389 52, 28 52.284, 28 53.500 C 28 54.742, 26.111 55, 17 55 L 6 55 6 58 L 6 61 32 61 L 58 61 58 58 L 58 55 46.917 55 C 38.496 55, 35.933 54.700, 36.247 53.750 C 36.522 52.919, 39.401 52.403, 44.830 52.210 C 49.324 52.050, 53 51.506, 53 51.002 C 53 47.715, 47.633 20.264, 46.792 19.250 C 45.328 17.485, 18.672 17.485, 17.208 19.250 M 25.456 25.687 C 24.655 26.488, 24 27.786, 24 28.571 C 24 29.357, 23.535 30, 22.968 30 C 21.224 30, 20.136 34.317, 21.330 36.500 C 21.931 37.600, 22.504 39.821, 22.604 41.435 C 22.854 45.498, 25.135 46.800, 32 46.800 C 38.950 46.800, 41.159 45.493, 41.372 41.254 C 41.458 39.540, 41.860 37.807, 42.264 37.402 C 43.598 36.068, 43.043 30.954, 41.500 30.362 C 40.675 30.045, 40 29.191, 40 28.464 C 40 27.738, 39.345 26.488, 38.544 25.687 C 36.598 23.741, 27.402 23.741, 25.456 25.687 M 27.639 27.694 C 26.444 28.889, 26.994 31, 28.500 31 C 29.325 31, 30 30.352, 30 29.559 C 30 27.888, 28.573 26.761, 27.639 27.694 M 34.639 27.694 C 33.444 28.889, 33.994 31, 35.500 31 C 36.325 31, 37 30.352, 37 29.559 C 37 27.888, 35.573 26.761, 34.639 27.694 M 0.481 31.031 C -0.612 32.800, 1.451 34.191, 4.628 33.828 C 8.648 33.369, 8.431 30.590, 4.344 30.194 C 2.608 30.025, 0.870 30.402, 0.481 31.031 M 56.481 31.031 C 55.388 32.800, 57.451 34.191, 60.628 33.828 C 64.648 33.369, 64.431 30.590, 60.344 30.194 C 58.608 30.025, 56.870 30.402, 56.481 31.031 M 24 34.441 C 24 35.298, 24.450 36, 25 36 C 25.550 36, 26 35.577, 26 35.059 C 26 34.541, 25.550 33.840, 25 33.500 C 24.450 33.160, 24 33.584, 24 34.441 M 38.583 33.866 C 38.152 34.563, 38.070 35.403, 38.400 35.733 C 39.295 36.628, 40.271 35.312, 39.787 33.862 C 39.449 32.846, 39.213 32.846, 38.583 33.866 M 28.679 37.153 C 24.540 41.870, 25.392 43.500, 32 43.500 C 36.217 43.500, 37.543 43.134, 37.780 41.903 C 38.059 40.458, 33.335 34, 32 34 C 31.695 34, 30.200 35.419, 28.679 37.153 M 31 53.417 C 31 54.288, 31.712 55, 32.583 55 C 33.454 55, 33.989 54.466, 33.771 53.813 C 33.153 51.958, 31 51.651, 31 53.417"
                  stroke="none"
                  fill="#fff"
                  fill-rule="evenodd"
                />
              </svg>
            </a>
          </div>
          <div class="wf social-item">
            <a href="https://api.whatsapp.com/send/?phone=905315728353&text&type=phone_number&app_absent=0" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="225" height="225" viewBox="0 0 225 225" version="1.1">
                <path
                  d="M 127 19.969 C 113.525 20.310, 102.381 20.682, 102.235 20.795 C 102.090 20.908, 101.079 22.462, 99.989 24.250 C 97.126 28.945, 97.425 33.325, 100.872 37.182 C 103.662 40.305, 104.017 40.408, 113.372 40.817 L 123 41.239 123 45.564 L 123 49.890 118.250 50.195 C 114.514 50.435, 113.298 50.960, 112.554 52.654 C 111.639 54.739, 110.945 54.821, 90.554 55.242 C 72.490 55.616, 68.704 55.970, 63.894 57.735 C 56.288 60.527, 51.377 63.789, 45.843 69.722 C 36.098 80.171, 34 87.764, 34 112.585 L 34 130.750 31 131.350 C 28.041 131.942, 28 132.037, 28 138.368 C 28 143.298, 28.367 144.927, 29.582 145.393 C 30.452 145.727, 43.412 146, 58.382 146 C 78.218 146, 85.925 145.675, 86.800 144.800 C 88.357 143.243, 88.357 133.757, 86.800 132.200 C 86.140 131.540, 84.858 131, 83.950 131 C 82.571 131, 82.193 129.356, 81.642 120.956 C 80.985 110.925, 81.403 106.608, 83.260 104.250 C 83.963 103.357, 88.212 103, 98.122 103 L 112 103 112 105.429 C 112 110.524, 113.710 111, 132 111 C 150.290 111, 152 110.524, 152 105.429 L 152 103 173.300 103 C 188.533 103, 194.942 102.658, 195.800 101.800 C 197.500 100.100, 197.500 57.900, 195.800 56.200 C 194.942 55.342, 188.549 55, 173.370 55 L 152.139 55 151.820 52.750 C 151.547 50.830, 150.803 50.455, 146.750 50.195 L 142 49.890 142 45.445 L 142 41 148.375 41 C 156.365 41, 159.961 40.292, 162.781 38.165 C 167.599 34.531, 167.172 25.628, 162 21.871 C 158.629 19.423, 155.434 19.249, 127 19.969 M 56.672 151.164 C 55.733 151.689, 53.364 155.299, 51.406 159.187 C 49.448 163.074, 45.781 169.361, 43.257 173.157 C 39.095 179.416, 38.667 180.613, 38.667 185.993 C 38.667 197.525, 46.595 205.496, 58 205.430 C 70.335 205.358, 79.483 194.766, 77.585 182.755 C 77.156 180.043, 74.780 175.237, 71.030 169.500 C 67.794 164.550, 64.132 158.379, 62.892 155.788 C 60.414 150.607, 59.234 149.730, 56.672 151.164"
                  stroke="none"
                  fill="#fff"
                  fill-rule="evenodd"
                />
                <path
                  d="M -0 112.504 L -0 225.009 112.750 224.754 L 225.500 224.500 225.754 112.250 L 226.009 0 113.004 0 L 0 0 -0 112.504 M 0.483 113 C 0.483 174.875, 0.603 200.188, 0.750 169.250 C 0.897 138.313, 0.897 87.688, 0.750 56.750 C 0.603 25.813, 0.483 51.125, 0.483 113 M 127 19.969 C 113.525 20.310, 102.381 20.682, 102.235 20.795 C 102.090 20.908, 101.079 22.462, 99.989 24.250 C 97.126 28.945, 97.425 33.325, 100.872 37.182 C 103.662 40.305, 104.017 40.408, 113.372 40.817 L 123 41.239 123 45.564 L 123 49.890 118.250 50.195 C 114.514 50.435, 113.298 50.960, 112.554 52.654 C 111.639 54.739, 110.945 54.821, 90.554 55.242 C 72.490 55.616, 68.704 55.970, 63.894 57.735 C 56.288 60.527, 51.377 63.789, 45.843 69.722 C 36.098 80.171, 34 87.764, 34 112.585 L 34 130.750 31 131.350 C 28.041 131.942, 28 132.037, 28 138.368 C 28 143.298, 28.367 144.927, 29.582 145.393 C 30.452 145.727, 43.412 146, 58.382 146 C 78.218 146, 85.925 145.675, 86.800 144.800 C 88.357 143.243, 88.357 133.757, 86.800 132.200 C 86.140 131.540, 84.858 131, 83.950 131 C 82.571 131, 82.193 129.356, 81.642 120.956 C 80.985 110.925, 81.403 106.608, 83.260 104.250 C 83.963 103.357, 88.212 103, 98.122 103 L 112 103 112 105.429 C 112 110.524, 113.710 111, 132 111 C 150.290 111, 152 110.524, 152 105.429 L 152 103 173.300 103 C 188.533 103, 194.942 102.658, 195.800 101.800 C 197.500 100.100, 197.500 57.900, 195.800 56.200 C 194.942 55.342, 188.549 55, 173.370 55 L 152.139 55 151.820 52.750 C 151.547 50.830, 150.803 50.455, 146.750 50.195 L 142 49.890 142 45.445 L 142 41 148.375 41 C 156.365 41, 159.961 40.292, 162.781 38.165 C 167.599 34.531, 167.172 25.628, 162 21.871 C 158.629 19.423, 155.434 19.249, 127 19.969 M 56.672 151.164 C 55.733 151.689, 53.364 155.299, 51.406 159.187 C 49.448 163.074, 45.781 169.361, 43.257 173.157 C 39.095 179.416, 38.667 180.613, 38.667 185.993 C 38.667 197.525, 46.595 205.496, 58 205.430 C 70.335 205.358, 79.483 194.766, 77.585 182.755 C 77.156 180.043, 74.780 175.237, 71.030 169.500 C 67.794 164.550, 64.132 158.379, 62.892 155.788 C 60.414 150.607, 59.234 149.730, 56.672 151.164"
                  stroke="none"
                  fill="#000"
                  fill-rule="evenodd"
                />
              </svg>
            </a>
          </div>
        </div>
        <div class="app-buttons">
          <a href="https://apps.apple.com/us/app/pazar-belediyesi/id6747127816" class="app-button" target="_blank">
            <img src="@/assets/images/AppStore.png" alt="App Store'dan İndirin" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.pazar.belediye" class="app-button" target="_blank">
            <img src="@/assets/images/GooglePlay.png" alt="Google Play'den Alın" />
          </a>
        </div>
        <div class="copyright">Pazar Belediyesi Tüm Hakları Saklıdır &copy; {{ currentYear }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from "@/services/service";

export default {
  name: "FooterComponent",

  created() {
    this.getMenu();
  },

  methods: {
    getMenu() {
      apiService
        .getHomeData("FooterMenus")
        .then((res) => {
          this.menus = res.model;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    goSelectMenu(data) {
      if (data.redirectUrl !== "") {
        const newTab = window.open(data.redirectUrl, "_blank");
        newTab.focus();
      } else {
        this.$router.push(data.url);
      }
    },
  },

  data() {
    return {
      menus: [],
      currentYear: new Date().getFullYear(), // Şu anki yılı alır
    };
  },
};
</script>

<style scoped>
.footer {
  background: #000;
  padding: 30px 50px;
}

.footer .row {
  padding: 0 0 0 30px;
}

.footer h5.title {
  color: #00a8ff;
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: bold;
}

.footer ul li {
  font-size: 14px;
  line-height: 24px;
}

.footer ul li a {
  transition: 300ms all;
  color: #fff;
}

.footer ul li a:hover {
  color: #00a8ff !important;
}

.footer .info p {
  font-size: 14px;
  line-height: 24px;
  color: #aaa;
}

.footer .info p a {
  font-size: 14px;
  line-height: 24px;
  color: #aaa;
  transition: 300ms all;
}

.footer .info p a:hover {
  font-size: 14px;
  line-height: 24px;
  color: #fff;
}

.footer .row .col-md-4:last-child {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}

.footer .socials {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer .socials .social-item {
  cursor: pointer;
}

.footer .socials svg {
  width: 36px;
  height: 36px;
  fill: #fff;
}

.footer .socials .x svg {
  width: 28px;
  height: 28px;
}

.footer .socials .vet svg {
  width: 31px;
  height: 31px;
}

.footer .copyright {
  color: #aaa;
  font-size: 14px;
}

a {
  cursor: pointer;
}

@media screen and (max-width: 576px) {
  .footer {
    padding: 20px 10px;
  }
}
/* App Store butonları */
.app-buttons {
  display: flex;
  gap: 12px;
  margin-top: 15px;
  align-items: center;
  justify-content: end;
}

.app-button {
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease, opacity 0.3s ease;
  cursor: pointer;
}

.app-button:hover {
  transform: translateY(-2px);
  opacity: 0.9;
}

.app-button img {
  display: block;
  max-height: 50px;
  object-fit: contain;
}

/* Responsive tasarım */
@media (max-width: 768px) {
  .app-buttons {
    flex-direction: row;
    gap: 8px;
    justify-content: space-between;
  }

  .app-button {
    flex: 1;
    max-width: calc(50% - 4px);
  }

  .app-button img {
    max-height: 45px;
  }

  .socials {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .app-buttons {
    gap: 6px;
  }

  .app-button img {
    max-height: 40px;
  }
}
</style>
